import { render } from "./ServicesTwo.vue?vue&type=template&id=67de3440"
import script from "./ServicesTwo.vue?vue&type=script&lang=js"
export * from "./ServicesTwo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__